import { render } from "./StatusRedGreenComponent.vue?vue&type=template&id=dedaa5ba&scoped=true"
import script from "./StatusRedGreenComponent.vue?vue&type=script&lang=js"
export * from "./StatusRedGreenComponent.vue?vue&type=script&lang=js"

import "./StatusRedGreenComponent.vue?vue&type=style&index=0&id=dedaa5ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedaa5ba"]])

export default __exports__